// @ts-nocheck
import React from 'react';
import NotAvailableYet from '../components/NotAvailableYet';

// Spectator ticket checkout is not built for RLE's event_ticket_purchases yet.
interface MobileTicketPurchaseProps {
  eventId: string;
  eventName: string;
  profileId: string;
  onBack: () => void;
  onPurchaseComplete: () => void;
}

const MobileTicketPurchase: React.FC<MobileTicketPurchaseProps> = ({ onBack }) => (
  <NotAvailableYet onBack={onBack} message="Buying spectator tickets in the app is not available yet." />
);

export default MobileTicketPurchase;
